import { lazy, Suspense } from "react"
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"

import { Providers } from "@/providers"
import type { RouterContext } from "@/main"

/**
 * Root route — sits above every URL. Mounts the app-wide providers, the
 * outlet, and (in dev only) the React Query devtools. The typed
 * `RouterContext` declared in `main.tsx` flows from here to every
 * `beforeLoad` / `loader` / `Route.useRouteContext()` downstream.
 */

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((m) => ({
        default: m.ReactQueryDevtools,
      }))
    )
  : () => null

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  return (
    <Providers>
      <Outlet />
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <ReactQueryDevtools buttonPosition="bottom-right" />
        </Suspense>
      )}
    </Providers>
  )
}
